"use client";

import { useEffect } from "react";

import { SITE_MARKDOWN, KEYSTONE_APPS } from "@/lib/agentDiscovery";

// Registers WebMCP tools (https://webmachinelearning.github.io/webmcp/) so
// browser-based AI agents can query the site directly. Feature-detected: a
// no-op in browsers without navigator.modelContext.
export default function WebMcpTools() {
  useEffect(() => {
    if (
      typeof navigator === "undefined" ||
      typeof navigator.modelContext?.provideContext !== "function"
    ) {
      return;
    }

    navigator.modelContext.provideContext({
      tools: [
        {
          name: "get_keystone_overview",
          description:
            "Get a markdown overview of KEYSTONE: its Shopify apps (Loyalty & Referrals, Product Options, AI SEO), key pages and machine-readable endpoints.",
          inputSchema: { type: "object", properties: {} },
          async execute() {
            return { content: [{ type: "text", text: SITE_MARKDOWN }] };
          },
        },
        {
          name: "list_changelog",
          description:
            "List recent Keystone product changelog entries (release notes), optionally filtered by app.",
          inputSchema: {
            type: "object",
            properties: {
              app: {
                type: "string",
                enum: KEYSTONE_APPS.map((app) => app.slug),
                description: "Filter by app slug.",
              },
              limit: {
                type: "number",
                description: "Max entries to return (default 20, max 100).",
              },
            },
          },
          async execute({ app, limit } = {}) {
            const params = new URLSearchParams();
            if (app) params.set("app", app);
            params.set("limit", String(Math.min(limit || 20, 100)));
            const response = await fetch(`/api/changelog?${params}`);
            const json = await response.json();
            return {
              content: [
                {
                  type: "text",
                  text: JSON.stringify(json.data ?? json, null, 2),
                },
              ],
            };
          },
        },
      ],
    });
  }, []);

  return null;
}
